var _defs, _path, _circle, _path2, _circle2, _circle3, _path3, _rect, _path4, _path5, _circle4, _rect2, _path6, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path7, _rect10, _rect11, _rect12, _rect13, _path8, _circle5, _path9, _path10, _path11, _path12, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}.cls-14{fill:url(#linear-gradient-14);}.cls-15{fill:url(#linear-gradient-15);}.cls-16{fill:url(#linear-gradient-16);}.cls-17{fill:url(#linear-gradient-17);}.cls-18{fill:url(#linear-gradient-18);}.cls-19{fill:url(#linear-gradient-19);}.cls-20{fill:url(#linear-gradient-20);}.cls-21{fill:url(#linear-gradient-21);}.cls-22{fill:url(#linear-gradient-22);}.cls-23{fill:url(#linear-gradient-23);}.cls-24{fill:url(#linear-gradient-24);}.cls-25{fill:url(#linear-gradient-25);}.cls-26{fill:url(#linear-gradient-26);}.cls-27{fill:url(#linear-gradient-27);}.cls-28{fill:url(#linear-gradient-28);}.cls-29{fill:url(#linear-gradient-29);}.cls-30{fill:url(#linear-gradient-30);}.cls-31{fill:url(#linear-gradient-31);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 19.73,
    y1: 13.37,
    x2: 19.73,
    y2: 5.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#273a9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#202f65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021e2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 19.73,
    y1: 49.32,
    x2: 19.73,
    y2: -10.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 19.73,
    y1: 47.62,
    x2: 19.73,
    y2: 21.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 19.73,
    y1: 41.57,
    x2: 19.73,
    y2: -16.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27e9de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#03a4ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2547a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 19.73,
    y1: 36.62,
    x2: 19.73,
    y2: -36.26,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 19.73,
    y1: 41.26,
    x2: 19.73,
    y2: 5.23,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 19.73,
    y1: 9.27,
    x2: 19.73,
    y2: -2.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 9.8,
    y1: 35.24,
    x2: 35.88,
    y2: 9.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#cce2e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8fa1bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 23.08,
    y1: 23.39,
    x2: 30.2,
    y2: 9.61,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 19.73,
    y1: 44.13,
    x2: 19.73,
    y2: 10.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3c57a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f39369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e94867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 19.73,
    y1: 21.62,
    x2: 19.73,
    y2: 13.87,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 20.08,
    y1: 21.62,
    x2: 20.08,
    y2: 13.87,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 19.73,
    y1: 41.14,
    x2: 19.73,
    y2: 33.39,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -186.98,
    y1: -121,
    x2: -186.98,
    y2: -128.75,
    gradientTransform: "matrix(1, 0, 0, 1, 201.85, 143.89)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -186.98,
    y1: -101.48,
    x2: -186.98,
    y2: -109.23,
    gradientTransform: "matrix(1, 0, 0, 1, 211.58, 141.31)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -294.4,
    y1: -348.36,
    x2: -294.4,
    y2: -356.1,
    gradientTransform: "translate(305.72 374.81) rotate(-0.01)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -294.4,
    y1: -328.84,
    x2: -294.4,
    y2: -336.58,
    gradientTransform: "matrix(1, 0, 0, 1, 322.55, 365.11)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -274.31,
    y1: -598.96,
    x2: -274.31,
    y2: -606.7,
    gradientTransform: "translate(284.28 630.34)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -274.31,
    y1: -579.44,
    x2: -274.31,
    y2: -587.18,
    gradientTransform: "translate(303.8 610.82)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 29.49,
    y1: 28,
    x2: 29.49,
    y2: 24.12,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -131.32,
    y1: -805.47,
    x2: -131.32,
    y2: -813.22,
    gradientTransform: "translate(142.48 841.73) rotate(0.01)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -118.12,
    y1: -805.22,
    x2: -120.34,
    y2: -803,
    gradientTransform: "translate(159.56 812.42)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 96.02,
    y1: -913.31,
    x2: 96.02,
    y2: -921.05,
    gradientTransform: "translate(-81.33 953.1) rotate(0.01)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 109.22,
    y1: -913.06,
    x2: 107,
    y2: -910.84,
    gradientTransform: "translate(-71.39 916.7)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 24.76,
    y1: 17.56,
    x2: 39.01,
    y2: 3.32,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 36,
    y1: 61,
    x2: 36,
    y2: 4.39,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 14.45,
    y1: 35.21,
    x2: 37.82,
    y2: 32.83,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 22.28,
    y1: 30.87,
    x2: 35.97,
    y2: 32.49,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 36,
    y1: 48.06,
    x2: 36,
    y2: 24.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 36,
    y1: 42.53,
    x2: 36,
    y2: 33.9,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 36,
    y1: 38.11,
    x2: 36,
    y2: 29.29,
    xlinkHref: "#linear-gradient-8"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "timer, stopwatch, setting, options, preferences") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.7,3H16.76a1.21,1.21,0,0,0-1.21,1.21v.36a1.21,1.21,0,0,0,1.21,1.21h0a1.58,1.58,0,0,1,1.58,1.58V9.1h2.79V7.36A1.58,1.58,0,0,1,22.7,5.79h0a1.21,1.21,0,0,0,1.21-1.21V4.21A1.21,1.21,0,0,0,22.7,3Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 19.73,
    cy: 25.31,
    r: 16.73
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.28,25.31H7.18v11a16.68,16.68,0,0,0,25.1,0Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 19.73,
    cy: 25.31,
    r: 12.55
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 19.73,
    cy: 25.31,
    r: 9.76
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M18.32,35a8.84,8.84,0,0,0,2.82,0V25.32H18.32Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 15.55,
    y: 3,
    width: 8.37,
    height: 2.79,
    rx: 1.21,
    ry: 1.21
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M19.73,12.76V25.31H32.28A12.55,12.55,0,0,0,19.73,12.76Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M19.73,15.55v9.76h9.76A9.76,9.76,0,0,0,19.73,15.55Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 19.73,
    cy: 25.32,
    r: 1.41
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 19.03,
    y: 14.85,
    width: 1.39,
    height: 1.39,
    rx: 0.49,
    ry: 0.49
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M19.73,16.25h.21a.49.49,0,0,0,.49-.49v-.41a.49.49,0,0,0-.49-.49h-.21Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 19.03,
    y: 34.37,
    width: 1.39,
    height: 1.39,
    rx: 0.49,
    ry: 0.49
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 14.15,
    y: 16.16,
    width: 1.39,
    height: 1.39,
    rx: 0.49,
    ry: 0.49,
    transform: "translate(-6.44 9.68) rotate(-29.99)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 23.91,
    y: 33.06,
    width: 1.39,
    height: 1.39,
    rx: 0.49,
    ry: 0.49,
    transform: "translate(-13.58 16.83) rotate(-30)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 10.58,
    y: 19.73,
    width: 1.39,
    height: 1.39,
    rx: 0.49,
    ry: 0.49,
    transform: "translate(-12.05 19.98) rotate(-59.99)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 27.49,
    y: 29.49,
    width: 1.39,
    height: 1.39,
    rx: 0.49,
    ry: 0.49,
    transform: "translate(-12.05 39.5) rotate(-60)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 9.27,
    y: 24.61,
    width: 1.39,
    height: 1.39,
    rx: 0.49,
    ry: 0.49,
    transform: "translate(-15.34 35.28) rotate(-90)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 28.79,
    y: 24.61,
    width: 1.39,
    height: 1.39,
    rx: 0.49,
    ry: 0.49,
    transform: "translate(4.18 54.8) rotate(-90)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M30.19,25.31V25.1a.49.49,0,0,0-.49-.49h-.41a.49.49,0,0,0-.49.49v.21Z"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 10.58,
    y: 29.49,
    width: 1.39,
    height: 1.39,
    rx: 0.49,
    ry: 0.49,
    transform: "translate(-9.22 55.05) rotate(-120.01)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 27.49,
    y: 19.73,
    width: 1.39,
    height: 1.39,
    rx: 0.49,
    ry: 0.49,
    transform: "translate(24.58 55.05) rotate(-120)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 14.15,
    y: 33.06,
    width: 1.39,
    height: 1.39,
    rx: 0.49,
    ry: 0.49,
    transform: "translate(10.84 70.42) rotate(-150.01)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 23.91,
    y: 16.16,
    width: 1.39,
    height: 1.39,
    rx: 0.49,
    ry: 0.49,
    transform: "translate(37.5 43.76) rotate(-150)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M34.54,11.73h0a1.39,1.39,0,0,1-2,0l-2-2a1.39,1.39,0,0,1,0-2h0a1.39,1.39,0,0,1,2,0l2,2A1.39,1.39,0,0,1,34.54,11.73Z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 36,
    cy: 36,
    r: 9
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M36.38,27,36,27a9,9,0,0,0-8.1,12.9A16.73,16.73,0,0,0,36.38,27Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M32,27.95a9,9,0,0,0-5,7.56A12.54,12.54,0,0,0,32,27.95Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M40,36h0a1.35,1.35,0,0,1,.39-1l.89-.9a.65.65,0,0,0,.1-.78L41,32.64a.65.65,0,0,0-.72-.3L39,32.66a1.35,1.35,0,0,1-1-.15h0a1.33,1.33,0,0,1-.6-.79L37,30.48a.65.65,0,0,0-.62-.48h-.84a.65.65,0,0,0-.62.48l-.34,1.24a1.33,1.33,0,0,1-.6.79h0a1.35,1.35,0,0,1-1,.15l-1.23-.32a.65.65,0,0,0-.72.3l-.42.73a.65.65,0,0,0,.1.78l.93.94A1.27,1.27,0,0,1,32,36h0a1.27,1.27,0,0,1-.35.91l-.93.94a.65.65,0,0,0-.1.78l.42.73a.65.65,0,0,0,.72.3L33,39.33a1.25,1.25,0,0,1,1,.15l0,0a1.25,1.25,0,0,1,.58.74L35,41.52a.65.65,0,0,0,.62.48h.84a.65.65,0,0,0,.62-.48l.34-1.25A1.31,1.31,0,0,1,38,39.5l.07,0a1.21,1.21,0,0,1,.93-.13l1.29.34a.65.65,0,0,0,.72-.3l.42-.73a.65.65,0,0,0-.1-.78l-.89-.9A1.35,1.35,0,0,1,40,36Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M34.54,40.11a1.12,1.12,0,0,1,.06.12L35,41.52a.65.65,0,0,0,.62.48h.84a.65.65,0,0,0,.62-.48l.34-1.25a1.27,1.27,0,0,1,.07-.15V36H34.54Z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 36,
    cy: 36,
    r: 1.46
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.4c0ce1aef65f44ab638bfc85cd76a92a.svg";
export { ForwardRef as ReactComponent };